/* eslint-disable jsx-a11y/img-redundant-alt */
import { CSSProperties } from "react";
import LogoDSCrm from "../../assets/preload/logo-fidelize.png";

type LogoProps = {
  style?: CSSProperties;
};

const Logo = ({ style }: LogoProps) => {
  return (
    <div
      test-id="image-logo-ds-marketing"
      style={{
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        ...style,
      }}
    >
      <img
        style={{ objectFit: "contain", width: "70%" }}
        alt="image-logo"
        src={LogoDSCrm}
      />
    </div>
  );
};

export default Logo;
